import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import mback from "../images/Back.png";
import srch from "../images/searchIcon.png";
import mysvg from "../images/zan1.svg"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Tooltip,
    Stack,
    Chip,
    Paper,
  } from "@mui/material";
import menuLine from "../images/menu-line.svg"
import RoomFee from '../menus/RoomFee';
import DialogContentText from '@mui/material/DialogContentText';
import Avatar from '@mui/material/Avatar';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { IconCalender } from '../images/IconCalender';
// import gregorian from "react-date-object/calendars/gregorian";
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Print from '@mui/icons-material/Print';
import AccountBalance from '@mui/icons-material/AccountBalance';
import Key from '@mui/icons-material/Key';
import Logout from '@mui/icons-material/Logout';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
// import HotelVoucher from "../reports/HotelVoucher";
import HotelInvoice from "../reports/HotelInvoice";
import Presents from "../menus/Presents";
import Room_Types from "../menus/Room_Types";
import HotelVoucher_Pdf from "../reports/HotelVoucher_Pdf";
import Permission from '../menus/Permission';
import Cost from '../menus/Cost';
import Resturant from '../menus/Resturant';

import Booking from '../pages/Booking';
import Repair from '../menus/Repair';
import { NestedMenuItem } from 'mui-nested-menu';
import { IconMenuItem } from 'mui-nested-menu';
import MyTable from '../menus/MyTable';
import UserControlReport from "../reports/UserControlReport";
import AgencyReport from "../reports/AgencyReport";
import RoomReport from "../reports/RoomReport";
import GlobalReport from "../reports/GlobalReport";
import BreakfastReport from "../reports/BreakfastReport";
import ResturantReport from '../reports/ResturantReport';
import RepairReport from "../reports/RepairReport";
import CostReport from "../reports/CostReport";
// import SaveIcon from "@mui/icons-material/Add";
import SaveIcon from '@mui/icons-material/Save';
// import EditIcon from "@mui/icons-material/Edit";
// import EditNoteIcon from '@mui/icons-material/EditDocument';
import EditNoteIcon from '@mui/icons-material/EditNote';
// import EditNoteIcon from '@mui/icons-material/EditDocument';
import DeleteIcon from "@mui/icons-material/Delete";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
// import DescriptionIcon from '@mui/icons-material/Description';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {  PictureAsPdf } from "@mui/icons-material";
import ExcelIcon from "../images/IconExcel";
const Style = styled.div`
    min-height: 100vh;
    width: 100vw;
    z-index: 100;
    display: flex;
    flex-direction: column;
    position: relative;
  background-color:black;
 background-image:url("${mback}");
   // background-image:"../images/zan1.png";
   // background-color:black;// var(--n-grey-01);
    * {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
            "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
            sans-seri;
    }
    &.persian-font {
        * {
            font-family:iranyekan ;
        }
    }
    .content {
        flex-grow: 1;
        min-height: 100svh;
    }
    .navpad {
        position: relative;
        height: 80px;
        width: 100%;
    }
    .calender {
      fill: var(--n-grey-2);
      width: 24px;
      height: 24px;
      display: block;
      margin-top:-4vh;
      margin-left:10vh;
    }
    .expand {
         //  flex-grow: 1;
     
            display: 'flex';
               //  margin-top: '10px';
               // width: 5px;
                   height: 40px; 
                margin-left: 25vh;
                // margin:0vh auto 0;
               //     background-color:red;
        }
        .row-search{
            display: 'flex';
                margin-top: -5.5vh;
                  /* width: 10vw;
                   height: 40px; */
               margin-left: -8vh ;
              //   margin:-6vh 2 0;
           

        }
        @media (max-width: 850px){

            .expand {
                               
                display: 'flex';
                 margin-top: '20px';
                  /* width: '50px';
                   height: '30px'; */
                    margin-left: '220px' ;
                    
            }
            .calender {
      fill: var(--n-grey-2);
      width: 24px;
      height: 24px;
      display: block;
      margin-top:-2vh;
      margin-left:8vh; 
    }
        }
    .navbar {
        width: calc(100% - calc(var(--universal-pad) * 2));
        z-index: 999;
       box-shadow: 0px 4px 50px -14px #00000028;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 0 var(--universal-pad);
      height: 40px;
        position: fixed;
        inset: 0 0 auto 0;
        background: black ; //var(--nav-bg);
        backdrop-filter: blur(30px);
        transition: all 0.15s ease-in-out;
        &.big {
            height: 40px;
            .logo {
                padding: 0;
                height: 50px;
            }
            .login {
                .desc-text {
                    font-size: 16px;
                }
            }
        }
        .logo {
            align-self: center;
            height: 40px;
            min-width: 25%;
            padding: 0 0;
            transition: all 0.15s ease-in-out;
            img {
                height: 100%;
            }
        }
        .menu-btn {
            /* display: none; */
        }
        .expand {
        //    flex-grow: 1;
           
        }

        .user-container {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color:yellow ;// EDD682 ; //var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            min-width: 150px;
            align-items: flex-end;
            .title {
                width: fit-content;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                font-weight: 700;
                text-decoration: none;
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                box-shadow: 0px 4px 50px -14px #00000028;
                display: none;
                flex-direction: column;
                position: absolute;
                top: calc(100% - 5px);
                left: 0;
                background-color: var(--n-grey-01);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                border-radius: 1rem;
                width: calc(100% + 16px);
                min-width: 150px;
                &.ltr {
                    left: auto;
                    right: 0;
                }
                .login-item {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    text-decoration: none;
                    color: inherit;
                    padding: 4px 0;
                    .icon {
                        img {
                            display: block;
                        }
                    }
                }
            }
            &:hover {
                .items {
                    display: flex;
                }
            }
        }
        .change-lan {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color: var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            .title {
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                background-color: var(--n-grey-1);
                font-weight: 700;
                color:black;// var(--n-grey-2);
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                position: absolute;
                display: none;
                flex-direction: column;
                top: calc(100% - 10px);
                right: -20px;
                left: -20px;
                background-color: #fff;
                padding: 2px;
                border-radius: 10px;
                box-shadow: 0px 4px 8px -2px #0000005f;
                .item {
                    text-decoration: none;
                    padding: 0.5rem 1rem;
                    text-align: center;
                    border-radius: 8px;
                    color: #000;
                    margin: 0 0;
                    border:1px solid #fff;
                    :first-child {
                        margin: 0 0 0.3rem;
                    }
                    :last-child {
                        margin: 0.3rem 0 0;
                    }
                    &.active {
                        background-color: #eee;
                        border:1px solid #ccc;
                    }
                }
            }
            &:hover {
                .items{
                    display: flex;
                }
            }
        }
        .items {
            display: flex;
            justify-content: center;
            width: 100%;
            margin: auto;
            .navitem {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 1rem;
                text-decoration: none;
                color: var(--n-grey-1);
                font-size: 14px;
                position: relative;
                .drop-data {
                    z-index: 5;
                    position: absolute;
                    display: none;
                    flex-direction: column;
                    top: calc(100% + 0px);
                    right: -50px;
                    left: -50px;
                    background-color: #fff;
                    padding: 2px;
                    border-radius: 10px;
                    box-shadow: 0px 4px 8px -2px #0000005f;
                    .navitem {
                        text-decoration: none;
                        padding: 0.5rem 0.5rem;
                        text-align: center;
                        border-radius: 8px;
                        color: #000;
                        margin: 0.3rem 0;
                        border:1px solid #fff;
                        :first-child {
                            margin: 0 0 0.3rem;
                        }
                        :last-child {
                            margin: 0.3rem 0 0;
                        }
                        &.active {
                            background-color: #eee;
                            border:1px solid #ccc;
                        }
                        &&:hover {
                            border:1px solid #ccc;
                        }
                    }

                }
                &:hover {
                    .drop-data {
                        display: flex;
                    }
                }
                &.active {
                    font-weight: 700;
                    color: var(--prime-1);
                }
            }
        }
        .far-side {
            min-width: 45%;
            display: flex;
            gap: 2rem;
            flex-direction: row;
            justify-content: flex-end;
        }
        @media (max-width: 850px) {
            .far-side {
            
           min-width: 15%;
            /* display: flex;
            
            gap: 2rem;
            flex-direction: row;
            justify-content: flex-end; */
        }
        }
    }
    .footer {
        color: var(--fsc-d-1);
        padding: 32px var(--universal-pad);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        box-shadow: 0px -4px 50px -14px #00000028;
        .container-1 {
            width: 25%;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .logo {
                img {
                    height: 50px;
                }
            }
            .desc {
                color: var(--n-grey-2);
            }
        }
        .container-2 {
            width: calc(50% - 4rem);
            margin: 0 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 1.5rem;
            color: var(--n-grey-2);
            .navitem {
                max-width: calc(100% / 6);
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0.5rem 0;
                text-decoration: none;
                color: var(--n-grey-2);
                font-size: 14px;
                font-weight: 500;
            }
        }
        .container-3 {
            width: 25%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .logos {
                width: 100px;
                height: 100px;
                a {
                    border-radius: var(--border-radius-2);
                    display: block;
                    width: 80px;
                    padding: 0.5rem;
                    background-color: var(--n-grey-1);
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
        }
    }
    .down{
        padding: 0.5rem 0;
        text-align: center;

        color: var(--fsc-d-1);
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        font-size: 0.7rem;
        a {
            color: var(--text-d-1);
            text-decoration: none;
            &:hover {
                color: var(--n-grey-1)
            }
        }
    }
    @media (max-width: 850px){
        .navbar {
            width: calc(100vw - 32px);
            padding: 0 16px 0;
            justify-content: end;
            &.big {
                .logo {
                    padding: 20px 0;
                    height: 40px;
                }
            }
            .expand {
                               
                display: 'flex';
                 margin-top: '10px';
                  width: '50px';
                   height: '30px';
                    margin-left: '220px' ;
                    
            }
            .logo {
                min-width: 150px;
                padding: 10px 0;
                position: absolute;
                top: 0;
                left: calc(50% - 75px);
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
            .items {
                display: none;
            }
            .change-lan {
                display: none;
            }
            
            .menu-btn {
                z-index: 980;
                overflow: visible;
                cursor: pointer;
                position: fixed;
                top: 10px;
                right: 16px;
                width: 40px;
                height: 40px;
                background-color: #fff;
                display: flex;
                justify-content: center;
                border-radius: 4px;
                transition: all 0.15s ease-in-out;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                &.ltr {
                    right: auto;
                    left: 16px;
                    .menu-container {
                        right: auto;
                        left: -80vw;
                        &.active {
                            left: 0vw;
                        }
                    }
                }
                &.big {
                    top: 20px;
                    width: 40px;
                    height: 40px;
                }
                .menu-btn-img {
                    width: 20px;
                    height: 20px;
                    margin: auto;
                    transition: all 0.3s ease-in-out;
                    &.big {
                        width: 23px;
                        height: 23px;
                    }
                }
                .bg {
                    z-index: 950;
                    position: fixed;
                    inset: 0 0 0 0;
                    width: 100vw;
                    height: 100vh;
                    background-color: #0000005f;
                }
                .menu-container {
                    z-index: 970;
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    background-color: var(--n-grey-01);
                    width: 80vw;
                    height: 100vh;
                    inset: 0 0 0 auto;
                    right: -80vw;
                    transition: all 0.3s ease-in-out;
                    &.active {
                        right: 0vw;
                    }
                    .logo-menu {
                        width: 40%;
                        margin: 70px auto 35px;
                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                    .menu-items {
                        display: flex;
                        flex-direction: column;
              float:'right';
                        .navitem {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding: 1rem;
                            text-decoration: none;
                            color: var(--fsc-d-1);
                            font-size: 16px;
                            border-bottom: 1px solid var(--bg-d-3);
                            :last-child{
                                border-bottom: none;
                            }
                            &.active {
                                background-color: #fff;
                                font-weight: 700;
                            }
                        }
                    }
                    .text-s {
                        margin: 1rem auto 0.5rem;
                    }
                    .change-lan {
                        display: flex;
                        flex-direction: column;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        color: var(--fsc-d-1);
                        font-size: 16px;
                        margin: 0 1rem;
                        .title {
                            padding: 1rem;
                        }
                        .items {
                            position: relative;
                            inset: 0;
                            display: flex;
                            flex-direction: column;
                            background-color: #fff;
                            padding: 2px;
                            border-radius: 10px;
                            box-shadow: none;
                        }
                    }
                    .socials {
                        margin: 0.5rem auto 5rem;
                        display: flex;
                        flex-direction: row;
                        .item {
                            margin: 0 0.5rem;
                            :last-child{
                                margin: 0 0.5rem 0 0;
                            }
                            :first-child{
                                margin: 0 0 0 0.5rem;
                            }
                        }
                    }
                }
                
            }
        }
        .footer {
            padding: 32px 16px;
            width: calc(100% - 32px);
            flex-direction: column;
            gap: 2rem;
            .container-1 {
                align-items: center;
                width: 100%;
            }
            .container-2 {
                width: 100%;
                margin: 0;
                .navitem {
                    max-width: calc(100% / 2);
                }
            }
            .container-3 {
                width: 100%;
                justify-content: center;
            }
        }
    }
`;

function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title" // فقط با گرفتن این ID میشه جابجا کرد
        cancel={'[class*="MuiDialogContent-root"]'} // از داخل محتوا نشه کشید
      >
        <Paper {...props} />
      </Draggable>
    );
  }
export default function PageLayout(props) {
    const presentsRef = useRef(null);
    //  console.log('mojavez=',props.Mojavez)
    const makeMojavez = () => {
      
        if (props.Mojavez.length > 0) {
                  setRoomPrice(props.Mojavez[3])
                    setAgencyFlag(props.Mojavez[4])  
                    setRoomTypeFlag(props.Mojavez[5])     
            setVoucherFlag(props.Mojavez[6].Per_View)
            setInvoiceFlag(props.Mojavez[7].Per_View)
            setResturantFlag(props.Mojavez[8])
          setPermissionsFlag( props.Mojavez[9])
         setRepairFlag(props.Mojavez[10])
         setCustFlag(props.Mojavez[11])
         SetUserReportFlag(props.Mojavez[13].Per_View)
         SetAgenReportFlag(props.Mojavez[14].Per_View)
         SetRoomtypeReportFlag(props.Mojavez[15].Per_View)
         SetglobalReportFlag(props.Mojavez[16].Per_View)
         SetResturantReportFlag(props.Mojavez[17].Per_View)
         SetbreakfastReportFlag(props.Mojavez[18].Per_View)
         SetRepairReportFlag(props.Mojavez[19].Per_View)
         SetCostReportFlag(props.Mojavez[20].Per_View)

        }
        else
        return []
    }
    useEffect(() => {
        makeMojavez()
    }, []);
    useEffect(() => {
        makeMojavez()
    }, [props.Mojavez]);

    const [menuPosition, setMenuPosition] = useState(null);
// const [agencyper ,setAgencyPer]=useState([])
const [repairper ,setRepairPer]=useState([])
// const [roomtypeper ,setRoomTypePer]=useState([])
    const location = useLocation();
    const [openm, setOpenm] = useState(false)
    const [top, setTop] = useState(1);
    const [scroll, setScrollState] = useState(0);
    const [Mydate, setMydate] = useState(props.date || new Date());

    const [RoomSetting, setRoomSetting] = useState(false);
    const [RoomPrice, setRoomPrice] = useState(false);
    const [Permissions, setPermissions] = useState(false);
    const [repairs, setRepairs] = useState(false);
    const [Costs, setCosts] = useState(false);
    const [resturant,setResturant]=useState(false);
    
    const [UserReport, SetUserReport] = useState(false);
    const [AgenReport, SetAgenReport] = useState(false);
    const [RoomtypeReport, SetRoomtypeReport] = useState(false);
    const [globalReport, SetglobalReport] = useState(false);
    const [breakfastReport, SetbreakfastReport] = useState(false);
    const [resturantreport, SetResturantReport] = useState(false);
    const [repairReport, SetRepairReport] = useState(false);
    const [costReport, SetCostReport] = useState(false);

    const [UserReportFlag, SetUserReportFlag] = useState(false);
    const [AgenReportFlag, SetAgenReportFlag] = useState(false);
    const [RoomtypeReportFlag, SetRoomtypeReportFlag] = useState(false);
    const [globalReportFlag, SetglobalReportFlag] = useState(false);
    const [breakfastReportFlag, SetbreakfastReportFlag] = useState(false);
    const [resturantreportFlag, SetResturantReportFlag] = useState(false);
    const [repairReportFlag, SetRepairReportFlag] = useState(false);
    const [costReportFlag, SetCostReportFlag] = useState(false);

   const [PermissionsFlag, setPermissionsFlag] = useState([]);
   const [RepairFlag, setRepairFlag] = useState(false);
    const [Agency, setAgency] = useState(false);
    const [RoomTypeFlag, setRoomTypeFlag] = useState([]);
    const [VoucherFlag, setVoucherFlag] = useState(false);
    const [InvoiceFlag, setInvoiceFlag] = useState(false);
    const [ResturantFlag, setResturantFlag] = useState(false);
    const [CustFlag, setCustFlag] = useState(false);
    const [AgencyFlag, setAgencyFlag] = useState([]);   
    const [RoomType, setRoomType] = useState(false);
    const [RoomVoucher, setRoomVoucher] = useState(false);
    const [RoomInvoice, setRoomInvoice] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [Room_Number, setRoom_Number] = useState(0);
    const [agency_save, setAgency_Save] = useState(false);
    const [agency_editflag, setAgency_EditFlag] = useState(false);
    const [roomtype_save, setRoomType_Save] = useState(false);
    const [repair_save, setRepair_Save] = useState(false);
    // const [cust_save, setCust_Save] = useState(false);
    const open = Boolean(anchorEl);
    let navigate = useNavigate();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const SetRoom = () => {
        return (
            <Dialog
                open={RoomSetting}
                // onClose={() => ZanNumb(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    ZanNumb(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 990,
                        maxHeight: 500,
                        width: 990,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
          <DialogTitle
              id="draggable-dialog-title"
              sx={{
                cursor: "move",
                userSelect: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                borderBottom: "1px solid #ddd",
                bgcolor: "#fafafa",
              }}
            >
                        {/* 🟢 وسط: عنوان دیالوگ */}
                        <Box sx={{ position: "absolute", left: "60%", transform: "translateX(-50%)" }}>
                <span style={{ fontWeight: 600, fontSize: "1rem" }}>Enter the room price</span>
              </Box>
      
              {/* 👈 سمت چپ: دکمه‌های اکشن */}
              <Stack direction="row" spacing={0.0001} alignItems="center">
              <Tooltip title="Template" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.temp()}>
                    <CloudDownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Upload" arrow>
                  <IconButton color="primary" disabled={!RoomTypeFlag.Per_Add} onClick={() => presentsRef.current?.upload()}>
                    <CloudUploadIcon  />
                  </IconButton>
                </Tooltip>
                <Tooltip title="filter" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.filter()}>
                    <FilterAltIcon  />
                  </IconButton>
                </Tooltip>
                <Tooltip title="remove filter" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.filteroff()}>
                    <FilterAltOffIcon  />
                  </IconButton>
                </Tooltip>
{/* 
                <Tooltip title="Print" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.print()}>
                    <Print  />
                  </IconButton>
                </Tooltip> */}
                <Tooltip title="PDF" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.pdf()}>
                    <PictureAsPdf  />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Excel" arrow>
                  <IconButton color="primary"  onClick={() => presentsRef.current?.excel()}>
                    <ExcelIcon  />
                  </IconButton>
                </Tooltip>
              </Stack>
      
    
              {/* 👉 سمت راست: دکمه خروج */}
              <Tooltip title="Exit" arrow>
                <IconButton color="error"onClick={() => ZanNumb(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <RoomFee ref={presentsRef} Room_No={Room_Number} permission={props.Mojavez}/>
                 
                </DialogContent>

            </Dialog>
        )
    }
    const SetVoucher = () => {
        return (
            <Dialog
                open={RoomVoucher}
                // onClose={() => setclosevoucher(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setclosevoucher(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 1000,
                        maxHeight: 700,
                        width: 1500,
                        height: 1500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle>Voucher</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <HotelVoucher_Pdf Room_No={Room_Number} />

                </DialogContent>
                <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setclosevoucher(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions>
            </Dialog>
        )
    }
    const SetInvoice = () => {
        return (
            <Dialog
                open={RoomInvoice}
                // onClose={() => setcloseinvoice(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setcloseinvoice(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 1000,
                        maxHeight: 700,
                        width: 1500,
                        height: 1500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle>Invoice</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <HotelInvoice Room_No={Room_Number} />

                </DialogContent>
                <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setcloseinvoice(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions>
            </Dialog>
        )
    }
    const SetshowAgnecy = () => {
        return (
            <Dialog
            open={Agency}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return;
              setcloseagency(false);
            }}
            PaperComponent={PaperComponent}
            PaperProps={{
              sx: {
                maxWidth: 800,
                maxHeight: 450,
                width: 800,
                height: 450,
                backgroundColor: "#F2F2F2",
              },
            }}
          >
            {/* 🔹 Header قابل جابه‌جایی */}
            <DialogTitle
              id="draggable-dialog-title"
              sx={{
                cursor: "move",
                userSelect: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                borderBottom: "1px solid #ddd",
                bgcolor: "#fafafa",
              }}
            >
              {/* 👈 سمت چپ: دکمه‌های اکشن */}
              <Stack direction="row" spacing={1} alignItems="center">
                <Tooltip title="New" arrow>
                  <IconButton color="primary" disabled={!AgencyFlag.Per_Add}  onClick={() => {presentsRef.current?.new()}}>
                    <FiberNewIcon />
                  </IconButton>
                </Tooltip>
      {/* disabled={!props.Mojavez[4].Per_Add} */}
   
                <Tooltip title="Save" arrow>
                  <IconButton color="primary" disabled={!agency_save} onClick={() => {presentsRef.current?.add()}}>
                    <SaveIcon />
                  </IconButton>
                </Tooltip>
                {/* disabled={!props.Mojavez[4].Per_Edit} */}
                <Tooltip title="Edit" arrow>
                  <IconButton color="primary" disabled={!(AgencyFlag.Per_Edit && agency_editflag)} onClick={() => presentsRef.current?.edit()}>
                    <EditNoteIcon />
                  </IconButton>
                </Tooltip>
                {/* disabled={!props.Mojavez[4].Per_Del} */}
                <Tooltip title="Delete" arrow>
                  <IconButton color="error" disabled={!(agency_editflag && AgencyFlag.Per_Del)} onClick={() => presentsRef.current?.del()}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
      
              {/* 🟢 وسط: عنوان دیالوگ */}
              <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                <span style={{ fontWeight: 600, fontSize: "1rem" }}>Agency</span>
              </Box>
      
              {/* 👉 سمت راست: دکمه خروج */}
              <Tooltip title="Exit" arrow>
                <IconButton color="error" onClick={() => setcloseagency(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </DialogTitle>
      
            {/* 📦 محتوا */}
            <DialogContent sx={{ p: 2 }}>
              <Presents ref={presentsRef} permission={props?.Mojavez} OnchangeAgencyEdit={OnchangeAgencyEdit} OnchangeAgencySave={OnchangeAgencySave}/>
            </DialogContent>
          </Dialog>
        )
    }
    const SetshowPermission = () => {
        return (
            <Dialog
                open={Permissions}
                // onClose={() => setPerm(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setPerm(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 720,
                        maxHeight: 500,
                        width: 720,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                {/* <DialogTitle style={{height:'10px'}}>Permission</DialogTitle> */}
                <DialogTitle
                   id="draggable-dialog-title"
                   sx={{
                     cursor: "move",
                     userSelect: "none",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "space-between",
                     p: 1,
                     borderBottom: "1px solid #ddd",
                     bgcolor: "#fafafa",
                   }}
                 >
                  {/* 👈 سمت چپ: دکمه‌های اکشن */}
                  <Stack direction="row" spacing={1} alignItems="center">
                    {/* <Tooltip title="New" arrow>
                      <IconButton color="primary"  onClick={() => presentsRef.current?.new()}>
                        <FiberNewIcon />
                      </IconButton>
                    </Tooltip> */}
          {/* disabled={!props.Mojavez[4].Per_Add} */}
       
                    <Tooltip title="Save" arrow>
                      <IconButton color="primary" disabled={!PermissionsFlag.Per_Add}  onClick={() => presentsRef.current?.add()}>
                        <SaveIcon />
                      </IconButton>
                    </Tooltip> 
                    {/* disabled={!props.Mojavez[4].Per_Edit} */}
                    <Tooltip title="Edit" arrow>
                      <IconButton color="primary"  disabled={!PermissionsFlag.Per_Edit}   onClick={() => presentsRef.current?.edit()}>
                        <EditNoteIcon />
                      </IconButton>
                    </Tooltip>
                    {/* disabled={!repairper.Per_Add} */}
                    {/* disabled={!repairper.Per_Edit} */}
                    {/* disabled={!props.Mojavez[4].Per_Del} */}
                    {/* <Tooltip title="Delete" arrow>
                      <IconButton color="error" disabled={!repairper.Per_Del} onClick={() => presentsRef.current?.del()}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip> */}
                  </Stack>
          
                  {/* 🟢 وسط: عنوان دیالوگ */}
                  <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                    <span style={{ fontWeight: 600, fontSize: "1rem" }}>Permission</span>
                  </Box>
          
                  {/* 👉 سمت راست: دکمه خروج */}
                  <Tooltip title="Exit" arrow>
                    <IconButton color="error" onClick={() => setPerm(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <Permission ref={presentsRef} permission={props.Mojavez}/>
                    {/* <MyTable /> */}
                </DialogContent>
                {/* <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '40px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setPerm(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions> */}
            </Dialog>
        )
    }
    const SetshowRepair = () => {
        return (
    
                <Dialog
                open={repairs}
                onClose={(event, reason) => {
                  if (reason === "backdropClick") return;
                  setRepair(false);
                }}
                PaperComponent={PaperComponent}
                PaperProps={{
                  sx: {
                    maxWidth: 800,
                    maxHeight: 450,
                    width: 800,
                    height: 450,
                    backgroundColor: "#F2F2F2",
                  },
                }}
              >
                {/* 🔹 Header قابل جابه‌جایی */}
                <DialogTitle
                  id="draggable-dialog-title"
                  sx={{
                    cursor: "move",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    borderBottom: "1px solid #ddd",
                    bgcolor: "#fafafa",
                  }}
                >
                  {/* 👈 سمت چپ: دکمه‌های اکشن */}
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Tooltip title="New" arrow>
                      <IconButton color="primary" disabled={!RepairFlag.Per_Add}  onClick={() =>{presentsRef.current?.new()}}>
                        <FiberNewIcon />
                      </IconButton>
                    </Tooltip>
          {/* disabled={!props.Mojavez[4].Per_Add} */}
       
                    <Tooltip title="Save" arrow>
                      <IconButton color="primary" disabled={!RepairFlag.Per_Add} onClick={() =>{ presentsRef.current?.add() }}>
                        <SaveIcon />
                      </IconButton>
                    </Tooltip>
                    {/* disabled={!props.Mojavez[4].Per_Edit} */}
                    <Tooltip title="Edit" arrow>
                      <IconButton color="primary" disabled={!RepairFlag.Per_Edit} onClick={() => presentsRef.current?.edit()}>
                        <EditNoteIcon />
                      </IconButton>
                    </Tooltip>
                    {/* disabled={!props.Mojavez[4].Per_Del} */}
                    <Tooltip title="Delete" arrow>
                      <IconButton color="error" disabled={!RepairFlag.Per_Del} onClick={() => presentsRef.current?.del()}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
          
                  {/* 🟢 وسط: عنوان دیالوگ */}
                  <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                    <span style={{ fontWeight: 600, fontSize: "1rem" }}>Repairs</span>
                  </Box>
          
                  {/* 👉 سمت راست: دکمه خروج */}
                  <Tooltip title="Exit" arrow>
                    <IconButton color="error" onClick={() => setRepair(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </DialogTitle>
          
                {/* 📦 محتوا */}
                <DialogContent sx={{ p: 2 }}>
                <Repair ref={presentsRef}   permission={props.Mojavez}/>
                </DialogContent>
              </Dialog>
        )
    }
    const SetshowCosts = () => {
        return (
            <Dialog
                open={Costs}
                // onClose={() => setCosts(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setCosts(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 500,
                        width: 950,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle style={{height:'10px'}}>Custs</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <Cost permission={props.Mojavez}/>
                 
                    {/* <MyTable /> */}
                </DialogContent>
                <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '40px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setCosts(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions>
            </Dialog>
        )
    }
    
    const SetshowResturant = () => {
        return (
            <Dialog
                open={resturant}
                // onClose={() => setResturant(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setResturant(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 500,
                        width: 950,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle style={{height:'20px',marginLeft:'350px'}}>Resturant
                
                     {/* 👉 سمت راست: دکمه خروج */}
              <Tooltip title="Exit" style={{float:'right'}} arrow>
                <IconButton color="error" onClick={() => setResturant(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <Resturant  permission={props.Mojavez}/>
                    {/* <Resturant permission={permission}  Room_No={Room_Number} ChangeXpage={ChangeXpage}  Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} /> */}
                    {/* <MyTable /> */}
                </DialogContent>
                <DialogActions    >
        
                </DialogActions>
            </Dialog>
        )
    }
  //   const SetshowBreakfast = () => {
  //     return (
  //         <Dialog
  //             open={breakfast}
  //             // onClose={() => setResturant(false)}
  //             onClose={(event, reason) => {
  //                 if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
  //                 setResturant(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
  //               }}
  //             PaperProps={{
  //                 sx: {
  //                     maxWidth: 950,
  //                     maxHeight: 500,
  //                     width: 950,
  //                     height: 500,
  //                     backgroundColor: '#F2F2F2'
  //                 },
  //                 component: 'form',
  //                 onSubmit: (event) => {
  //                     event.preventDefault();
  //                     // ZanNumb(false);
  //                 },
  //             }}
  //         >
  //             <DialogTitle style={{height:'20px',marginLeft:'350px'}}>Resturant
              
  //                  {/* 👉 سمت راست: دکمه خروج */}
  //           <Tooltip title="Exit" style={{float:'right'}} arrow>
  //             <IconButton color="error" onClick={() => setResturant(false)}>
  //               <CloseIcon />
  //             </IconButton>
  //           </Tooltip>
  //             </DialogTitle>
  //             <DialogContent>
  //                 <DialogContentText>

  //                 </DialogContentText>
  //                 <Breakfast  permission={props.Mojavez}/>
  //                 {/* <Resturant permission={permission}  Room_No={Room_Number} ChangeXpage={ChangeXpage}  Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} /> */}
  //                 {/* <MyTable /> */}
  //             </DialogContent>
  //             <DialogActions    >
      
  //             </DialogActions>
  //         </Dialog>
  //     )
  // }
    const SetshowUserReport = () => {
        return (
            <Dialog
                open={UserReport}
                // onClose={() => SetUserReport(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    SetUserReport(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}

                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 1010,
                        maxHeight: 510,
                        width: 1010,
                        height: 510,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
              
                <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
         
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>User Control</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => SetUserReport(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <UserControlReport />
                    {/* <MyTable /> */}
                </DialogContent>

            </Dialog>
        )
    }
    const SetshowAgencyReport = () => {
        return (
            <Dialog
                open={AgenReport}
                // onClose={() => SetAgenReport(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    SetAgenReport(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 1010,
                        maxHeight: 520,
                        width: 1010,
                        height: 520,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
               
                <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
         
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Agency Report</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => SetAgenReport(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <AgencyReport />
                    {/* <MyTable /> */}
                </DialogContent>

            </Dialog>
        )
    }
    const SetshowRoomReport = () => {
        return (
            <Dialog
                open={RoomtypeReport}
                // onClose={() => SetRoomtypeReport(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    SetRoomtypeReport(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 500,
                        width: 950,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >

                <DialogTitle
                  id="draggable-dialog-title"
                  sx={{
                    cursor: "move",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    borderBottom: "1px solid #ddd",
                    bgcolor: "#fafafa",
                  }}
                >
              {/* 👈 سمت چپ: دکمه‌های اکشن */}
              <Stack direction="row" spacing={1} alignItems="center">
                       </Stack>
      
              {/* 🟢 وسط: عنوان دیالوگ */}
              <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                <span style={{ fontWeight: 600, fontSize: "1rem" }}>Room Report</span>
              </Box>
      
              {/* 👉 سمت راست: دکمه خروج */}
              <Tooltip title="Exit" arrow>
                <IconButton color="error"onClick={() => SetRoomtypeReport(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <RoomReport  />
                    {/* <MyTable /> */}
                </DialogContent>
                <DialogActions    >
                    {/* <Stack direction="row" spacing={1} style={{ paddingRight: '40px' }}>
                        <Chip label="Exit" color="primary" onClick={() => SetRoomtypeReport(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack> */}


                </DialogActions>
            </Dialog>
        )
    }
    const SetshowRoomType = () => {
        return (

                    <Dialog
                    open={RoomType}
                    onClose={(event, reason) => {
                      if (reason === "backdropClick") return;
                      setcloseagency(false);
                    }}
                    PaperComponent={PaperComponent}
                    PaperProps={{
                      sx: {
                        maxWidth: 700,
                        maxHeight: 450,
                        width: 700,
                        height: 450,
                        backgroundColor: "#F2F2F2",
                      },
                    }}
                  >
                    {/* 🔹 Header قابل جابه‌جایی */}
                    <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Tooltip title="New" arrow>
                          <IconButton color="primary" disabled={!RoomTypeFlag.Per_Add} onClick={() => {setRoomType_Save(true); presentsRef.current?.new()}}>
                            <FiberNewIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Save" arrow>
                          <IconButton color="primary" disabled={!roomtype_save}  onClick={() => {presentsRef.current?.add();setRoomType_Save(false)}}>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Edit" arrow>
                          <IconButton color="primary" disabled={!RoomTypeFlag.Per_Edit}  onClick={() => presentsRef.current?.edit()}>
                            <EditNoteIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Delete" arrow>
                          <IconButton color="error" disabled={!RoomTypeFlag.Per_Del}  onClick={() => presentsRef.current?.del()}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Room Type</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setcloseroomtype(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
              
                    {/* 📦 محتوا */}
                    <DialogContent sx={{ p: 2 }}>
                          <Room_Types  ref={presentsRef}  permission={props.Mojavez}/>
                    </DialogContent>
                  </Dialog>
        )
    }
    const SetshowGlobalReport = () => {
        return (
            <Dialog
            open={globalReport}
            onClose={(event, reason) => {
              if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
              SetglobalReport(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
            }}
                 PaperComponent={PaperComponent}
            PaperProps={{
              sx: {
                maxWidth: 1220,
                maxHeight: 600,
                width: 1220,
                height: 600,
                backgroundColor: "#F2F2F2",
              },
              component: "form",
              onSubmit: (event) => {
                event.preventDefault();
              },
            }}
          >

            <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                             <Stack direction="row" spacing={1} alignItems="center">
                <Tooltip title="Excel" arrow>
                  <IconButton color="primary" disabled={false}  onClick={() => {presentsRef.current?.excel()}}>
                    <ExcelIcon />
                  </IconButton>
                </Tooltip>
      {/* disabled={!props.Mojavez[4].Per_Add} */}
   
                <Tooltip title="Pdf" arrow>
                  <IconButton color="primary" disabled={false} onClick={() => {presentsRef.current?.pdf()}}>
                    <PictureAsPdf />
                  </IconButton>
                </Tooltip>
                {/* disabled={!props.Mojavez[4].Per_Edit} */}
                <Tooltip title="Print" arrow>
                  <IconButton color="primary" disabled={false} onClick={() => presentsRef.current?.print()}>
                    <Print />
                  </IconButton>
                </Tooltip>
             
              </Stack>
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Global Report</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => SetglobalReport(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
              
            <DialogContent>
              <DialogContentText></DialogContentText>
              <GlobalReport ref={presentsRef}/>
            </DialogContent>
            <DialogActions>

            </DialogActions>
          </Dialog>
          
        )
    }
    const SetshowResturantReport = () => {
        return (
            <Dialog
                open={resturantreport}
                // onClose={() => setBreakfastRep(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setResturantRep(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 550,
                        width: 950,
                        height: 550,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
   
                <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
         
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Resturant Report</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setResturantRep(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <ResturantReport />
                    {/* <MyTable /> */}
                </DialogContent>
   
            </Dialog>
        )
    }
    const SetshowBreakfastReport = () => {
      return (
          <Dialog
              open={breakfastReport}
              // onClose={() => setBreakfastRep(false)}
              onClose={(event, reason) => {
                  if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                  setBreakfastRep(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                }}
                PaperComponent={PaperComponent}
              PaperProps={{
                  sx: {
                      maxWidth: 950,
                      maxHeight: 550,
                      width: 950,
                      height: 550,
                      backgroundColor: '#F2F2F2'
                  },
                  component: 'form',
                  onSubmit: (event) => {
                      event.preventDefault();
                      // ZanNumb(false);
                  },
              }}
          >
 
              <DialogTitle
                    id="draggable-dialog-title"
                    sx={{
                      cursor: "move",
                      userSelect: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1,
                      borderBottom: "1px solid #ddd",
                      bgcolor: "#fafafa",
                    }}
                  >
                    {/* 👈 سمت چپ: دکمه‌های اکشن */}
                    <Stack direction="row" spacing={1} alignItems="center">
       
                    </Stack>
            
                    {/* 🟢 وسط: عنوان دیالوگ */}
                    <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                      <span style={{ fontWeight: 600, fontSize: "1rem" }}>Breakfast Report</span>
                    </Box>
            
                    {/* 👉 سمت راست: دکمه خروج */}
                    <Tooltip title="Exit" arrow>
                      <IconButton color="error" onClick={() => setBreakfastRep(false)}>
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </DialogTitle>
              <DialogContent>
                  <DialogContentText>

                  </DialogContentText>
                  <BreakfastReport />
                  {/* <MyTable /> */}
              </DialogContent>
 
          </Dialog>
      )
  }
    const SetshowRepairReport = () => {
        return (
            <Dialog
                open={repairReport}
                // onClose={() => setRepairRep(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setRepairRep(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 500,
                        width: 950,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
    
                <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
         
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Repair Report</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setRepairRep(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <RepairReport />
                    {/* <MyTable /> */}
                </DialogContent>

            </Dialog>
        )
    }
    const SetshowCostReport = () => {
        return (
            <Dialog
                open={costReport}
              
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setCostRep(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                  PaperComponent={PaperComponent}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 500,
                        width: 950,
                        height: 500,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
             
                <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
         
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Cost Report</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setCostRep(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>    <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <CostReport />
                    {/* <MyTable /> */}
                </DialogContent>
                {/* <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '40px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setCostRep(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions> */}
            </Dialog>
        )
    }
    useEffect(() => {
        document.addEventListener('scroll', setScroll);
        return () => {
            document.removeEventListener('scroll', setScroll);
        }
    }, [])
    const setScroll = (e) => {
        setScrollState(window.scrollY)
    }
    useEffect(() => {
        if (scroll > 30) {
            if (top === 1) {
                setTop(0)
            }
        } else {
            setTop(1)
        }
    }, [scroll, top]);
    const onChangeDate = (e) => {
          //  setMydate(e)
          const newDate = e.toDate();
          setMydate(newDate); // ✅ ابتدا state محلی
         
        let y = e.year;
        let m = e.month;
        let d = e.day;
        props.onChangeDate(newDate)
        props.ClearZan();
       props.GetData(y, m, d);
    

    }
    function ZanNumb(e) {
        setRoomSetting(e)
    };

    function setclosevoucher(e) {
        setRoomVoucher(e)
    };
    const OnchangeAgencyEdit=(e)=> {
      setAgency_EditFlag(e)
  };
  const OnchangeAgencySave=(e)=> {
    setAgency_Save(e)
};
    function setcloseinvoice(e) {
        setRoomInvoice(e)
    };
    function setcloseagency(e) {
        setAgency(e)
    };
    function setPerm(e) {
        setPermissions(e)
    };
    function setRepair(e) {
        setRepairs(e)
    };
    function setUser(e) {
        SetUserReport(e)
    };
    function setAgencyRep(e) {
        SetAgenReport(e)
    };
    function setRoomRep(e) {
        SetRoomtypeReport(e)
    };
    
    function setGlobalRep(e) {
        SetglobalReport(e)
    };
    

    function setResturantRep(e) {
      SetResturantReport(e)
  };
  function setBreakfastRep(e) {
    SetbreakfastReport(e)
};
    function setRepairRep(e) {
        SetRepairReport(e)
    };
    function setCostRep(e) {
        SetCostReport(e)
    };
    function setcloseroomtype(e) {
        setRoomType(e)
    };
    const makeNavItems = () => {
        return (
            <React.Fragment>
                {/* sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', width: '0px', backgroundColor: 'yellow', direction: 'ltr' }} */}
                <Box sx={{ display: 'flex' ,marginRight:'30px', direction: 'rtl' }}>
                    <Tooltip >
                        <IconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <Avatar sx={{ width: 32, height: 32,marginLeft:'-200px' }}>M</Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={() => setRoomVoucher(true)} disabled={!VoucherFlag}>
                        <Print /> Voucher
                    </MenuItem>
                    <MenuItem onClick={() => setcloseinvoice(true)} disabled={!InvoiceFlag}>
                        <Print /> Invoice
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => setAgency(true)} disabled={!AgencyFlag.Per_View}>
                        <ListItemIcon>
                            <AccountBalance fontSize="small" />
                        </ListItemIcon>
                        Agency
                    </MenuItem>
                    <MenuItem onClick={() => setRoomType(true)} disabled={!RoomTypeFlag.Per_View}>
                        <ListItemIcon>
                            <PersonAdd fontSize="small" />
                        </ListItemIcon>
                        Room Type
                    </MenuItem>
                    <MenuItem onClick={() => setRoomSetting(true)} disabled={!RoomPrice.Per_View}>
                        <ListItemIcon>
                            <Settings fontSize="small" />
                        </ListItemIcon>
                        Room prices
                    </MenuItem>
                    <MenuItem onClick={() => setPerm(true)} disabled={!PermissionsFlag.Per_View}>
                        <ListItemIcon>
                            <Key fontSize="small" />
                        </ListItemIcon>
                        permission
                    </MenuItem>
                    <MenuItem onClick={() => setRepair(true)} disabled={!RepairFlag.Per_View}>
                        <ListItemIcon>
                            <Key fontSize="small" />
                </ListItemIcon>
                        Repairs
                    </MenuItem>
                    <MenuItem onClick={() => setCosts(true)} disabled={!CustFlag.Per_View}>
                        <ListItemIcon>
                            <Key fontSize="small" />
                        </ListItemIcon>
                        Costs
                    </MenuItem>
                    <MenuItem onClick={() => setResturant(true)} disabled={!ResturantFlag.Per_View}>
                        <ListItemIcon>
                            <Key fontSize="small" />
                        </ListItemIcon>
                        Resturant
                    </MenuItem>
                    <Divider />
                    <NestedMenuItem
                        leftIcon={<ArrowLeft />}
                        label="Reports"
                        parentMenuOpen={open}
                    >
                        <IconMenuItem
                            onClick={() => setUser(true)}
                            leftIcon={<Print />}
                            disabled={!UserReportFlag}
                            label="Users Report"
                        />
                        <IconMenuItem
                            onClick={() => setAgencyRep(true)}
                            leftIcon={<Print />}
                            disabled={!AgenReportFlag}
                            label="Agency Report "
                        />
                        <IconMenuItem
                            onClick={() => setRoomRep(true)}
                            leftIcon={<Print />}
                            disabled={!RoomtypeReportFlag}
                            label="Rooms Report "
                        />
                           <IconMenuItem
                            onClick={() => setGlobalRep(true)}
                            leftIcon={<Print />}
                            disabled={!globalReportFlag}
                            label="Global Report "
                        />
                        <IconMenuItem
                            onClick={() => setResturantRep(true)}
                            leftIcon={<Print />}
                            disabled={!resturantreportFlag}
                            label="Resturant Report "
                        />
                        <IconMenuItem
                            onClick={() => setBreakfastRep(true)}
                            leftIcon={<Print />}
                            disabled={!breakfastReportFlag}
                            label="Breakfast Report "
                        />
                              <IconMenuItem
                            onClick={() => setRepairRep(true)}
                            leftIcon={<Print />}
                            disabled={!repairReportFlag}
                            label="Rrpair Report "
                        />
                         <IconMenuItem
                            onClick={() => setCostRep(true)}
                            leftIcon={<Print />}
                            disabled={!costReportFlag}
                            label="Cost Report "
                        />
                    </NestedMenuItem>
                    <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </Menu>
                {/* <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
      {/* <NestedMenuItem
        leftIcon={<Avatar />}
        rightIcon={<Avatar />}
        label="Top Level"
        parentMenuOpen={open}
      > 
        <MenuItem onClick={handleClose}>Standard1 </MenuItem>
        <MenuItem onClick={handleClose}>Standard2!</MenuItem>
        <MenuItem onClick={handleClose}>Standard3</MenuItem>
        <MenuItem onClick={handleClose}>Standard4</MenuItem>

        <IconMenuItem
          onClick={handleClose}
          leftIcon={<Avatar />}
             label="Icon Menu Item"
        />
        <NestedMenuItem
          leftIcon={<ArrowLeft />}
          label="Go deeper!"
          parentMenuOpen={open}
        >
          <MenuItem onClick={handleClose}>Standard !</MenuItem>
          <IconMenuItem
            onClick={handleClose}
            leftIcon={<Avatar />}
            rightIcon={<Avatar />}
            label="Icon Menu "
          />
        </NestedMenuItem>
        <NestedMenuItem
          leftIcon={<Avatar />}
          label="hovering"
          parentMenuOpen={open}
          delay={500}
        >
          <MenuItem onClick={handleClose}>I was delayed!</MenuItem>
        </NestedMenuItem>*/}
                {/* </NestedMenuItem> 
    </Menu> */}
            </React.Fragment>
        );
    }
    const onsettingroom = () => {
        props.zannumb(true);
    }
    const openMenu = () => {
        setOpenm(!openm)
    }
    const makeLang = (lan) => {
        let pathname = location.pathname

        // let search = location.state.
        if (lan !== '') {
            localStorage.setItem("lang", lan);
            pathname = pathname.split('/');
            pathname.splice(1, 1);
            if (pathname.length === 1) {
                pathname = ['', '']
            }
            pathname = pathname.join('/')
            if (location.search) {
                pathname = pathname + location.search
            }
        }

    }
    const ctaNav = (lan, direction) => {
        // if(props.user.email){
        // logined // menus

        // let filtered = props.login.ctas.filter((v) => {
        //         //  console.log(v)
        //     if(!v.premission){
        //         return true
        //     }
        //     if(!v.premission.length){
        //         return true
        //     }
        //     for (let i = 0; i < v.premission.length; i++) {
        //         const per = v.premission[i];
        //         // if(per === "admin"){
        //         //     return havePermission(props.user.permission, {Agency_Id: 0, Obj_Code: 1})
        //         // }
        //     }
        //     return false;
        // })
        // let ctas = filtered.map((v,i) => {
        //     return (
        //         <a href={"/"+lan+v.route} target={v.target} key={i} className="login-item">
        //             <div className="icon">
        //                 <img src={v.icon} alt={v.title[lan]}/>
        //             </div>
        //             <div className="spacer">
        //             </div>
        //             <div className="text">
        //                 {v.title[lan]}
        //             </div>
        //         </a>
        //     )
        // })
        // return (
        //     <div className="user-container">
        //         <div className="title">
        //             {/* <IconUser/> */}
        //         </div>
        //         <div className={"items "+ direction}>
        //             {/* {ctas} */}
        //         </div>
        //     </div>
        // )

        // }

        // return (
        //     // <div className='row-search' style={{ justifyContent: "flex-start" }} >
        //     //     {/* <IconCalender className={"calender"}/> */}
        //     //     {/* <label className={"label-textinput " } onClick={onsettingroom} style={{marginLeft:"120px"}}> */}
        //     //     <Chip color="success" style={{ marginLeft: "320px", cursor: 'pointer', marginTop: '5px' }} label="Setting Room" size="medium" avatar={<Avatar src="logo512.png"
        //     //         style={{ cursor: 'pointer' }} onClick={onsettingroom} />} onClick={onsettingroom} />
        //     // </div>

        //     // <div className="user-container">

        //     //     <Link to={"/login"} className="title">
        //     //         <Person/>
        //     //         Login
        //     //         {/* {props.login.title["en"]} */}
        //     //     </Link>
        //     // </div>
        // )
    }

    let direction = 'ltr';
    let lan = props.language;

    let lanName = "En"; // props.language.title;
    // if(props.language.dir) {
    //     direction = props.language.dir
    // }
    direction = "ltr"
    return (

        <Style className={((direction === "rtl") ? 'persian-font' : '')} style={{ direction: direction, fontFamily: ((direction) ? 'iranyekan' : '') }}>
            <div className={"navbar" + (top ? " big" : "")} style={{ marginTop: '10px' }}>
                <Link to="../../" className="logo">
                    <img src={props.mainLogo} alt="www.luxinhotel.com" />
                </Link>

                {/*  <div className="items" style={{  'rtl' }}>
                     {makeNavItems()}
                    {makeNavItems()}
                </div> */}

                {/* <div className={'search-box ' + lan.dir} sx={{display:'flex',top:'50px'}}> */}
        {/* style={{ display: 'flex', marginTop: '10px', width: '50px', height: '30px', marginLeft: '220px' }} */}
                <div className="expand"  >

                    <img  src={srch} alt='Booking'  style={{width:'250px'}}onClick={() => navigate("/booking")}  />
                    {/* style={{ display: 'flex', marginTop: '0px', marginLeft: '-250px' }} */}
                    <div className='row-search' >

                        <DatePicker style={{ width: '100px', height: '30px', backgroundColor: '#D9D9D9' }}

                            //  inputClass={"rmdp-input " + "text-field" + " "}
                            className={((window.innerWidth < 850) ? "rmdp-mobile " : "")}
                            name={"currendate"}
                            required={true}
                            disabled={false}
                            calendarPosition="bottom"
                            //  minDate={minDate}
                          //  calendar={gregorian}
                            locale={'en'}
                            value={props.selectedDate}
                            onChange={onChangeDate}
                            range={false}
                            rangeHover={false}

                        />
    <IconCalender className={"calender"} />
                    
                    </div>
                </div>

                {/* </div> */}


                {/* <Link to="/" className="logo"> */}

                {/* <img src={srch} alt={< hotelvoucher />} onClick={() => { return (<hotelvoucher />) }} style={{ width: "150px", height: "30px" }} /> */}
                {/* <img src={props.mainLogo} alt="farazandishan" /> */}
                {/* </Link> */}

                <div className="far-side">
                    {ctaNav(lan, direction)}

                </div>
                <div style={{ direction: 'rtl' }}>
                    {/* <img src={menuLine} onClick={openMenu} className={"menu-btn-img" + (top ? " big" : "")} alt="menu"/> */}
                    {/* <div className="bg" onClick={openMenu} style={{ display: ((openm) ? 'block' : 'none') }}></div>
                    <div className={`menu-container ${((open) ? 'active' : '')}`} > */}


                    {makeNavItems()}
                    {SetRoom()}
                    {SetVoucher()}
                    {SetInvoice()}
                    {SetshowAgnecy()}
                    {SetshowRoomType()}
                    {SetshowPermission()}
                    {SetshowRepair()}
                    {SetshowCosts()}
                    {SetshowResturant()}

                    {SetshowUserReport()}
                    {SetshowAgencyReport()}
                    {SetshowRoomReport()}
                    {SetshowGlobalReport()}
                  {  SetshowResturantReport()}
                    {SetshowBreakfastReport()}
                    {SetshowRepairReport()}
                    {SetshowCostReport()}
                    {/* </div> */}
                </div>

            </div>
            <div className="content">
                {props.children}

            </div>
            {/* <div className="footer">
                <div className="container-1">
                    <div className="logo">
                        <img src={props.mainLogo} alt="farazandishan" />
                    </div>
                    <div className="desc">
                       
                    </div>
                </div>
                <div className="container-2">
                    
                </div>
                <div className="container-3">
                    <div className="logos">
                        <a referrerPolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=489621&Code=HqTSsnKp4nlEmapzIkayVMbEx21dfBzg'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=489621&Code=HqTSsnKp4nlEmapzIkayVMbEx21dfBzg' alt='' style={{ cursor: "pointer" }} code='HqTSsnKp4nlEmapzIkayVMbEx21dfBzg' /></a>
                    </div>
                </div>
            </div> */}
            {/* <div className="down">
                Copy Right    {/* {props.texts['copyright'][lan]} 
            </div> */}
        </Style>
    );
}